import { useState, useEffect } from 'react';
import UserModule from './settings/AccountSettings';
import SuccessComponent from './Success';
import Products from './Products';
import Cart from './Cart';
import { STATE } from '../classes/Enum';
import Item from '../classes/Item';
import { getInventory } from '../api/inventory';

const Main = ({ state, cart, setCart, setState, stripePromise, user, userState, setUserState }) => {
    const [transactionId, setTransactionId] = useState(null);
    const [items, setItems] = useState([]); // Available items
    const [totalPrice, setTotalPrice] = useState(0);
    const products = [STATE.OVERVIEW, STATE.SEALED, STATE.PACK, STATE.SINGLE, STATE.PROMO]

    function isTokenExpired(token) {
      if (!token) return true;
    
      const payload = JSON.parse(atob(token.split(".")[1])); // Decode token
      return payload.exp * 1000 < Date.now(); // Check if expired
    }

    useEffect(() => {
      const token = localStorage.getItem("accessToken");

      if (token && isTokenExpired(token)) {
        localStorage.clear();
        window.location.reload();
      }
    }, [])

    useEffect(() => {
        // Fetch the data from the API
        getInventory().then(response => {
            // Convert the raw product data into instances of the Item class
            const fetchedItems = response.map(product => {
              return new Item(product.id, product.product_name, Number(product.price).toFixed(2), product.quantity, product.type, product.image_url, product.series_name, product.set_name, product.subtext);
            });
    
            const inStock = fetchedItems.filter(item => item.quantity > 0);
            const outStock = fetchedItems.filter(item => item.quantity <= 0);
            setItems([...inStock, ...outStock]); // Combine in-stock first, out-stock last
          })
          .catch(error => {
            console.error('There was an error fetching the data!', error);
          });
      }, []);

  return (
    <div className="main">
        {products.includes(state) &&  <Products cart={cart} setCart={setCart} items={items} state={state} />}
        {state === STATE.CART && <Cart cart={cart} setState={setState} setCart={setCart} setTransactionId={setTransactionId} setTotalPrice={setTotalPrice} stripePromise={stripePromise} user={user}/>}
        {state === STATE.SUCCESS && <SuccessComponent transactionId={transactionId} totalPrice={totalPrice} />}
        {state === STATE.PROFILE && <UserModule user={user} items={items} userState={userState} setUserState={setUserState}/>}
    </div>
  );
};

export default Main;
